import 'whatwg-fetch'
const env = process.env;

const getLifecyclePlatforms = (data) => {
  return fetch(`${env.VUE_APP_trimaster}/api/v1/ag_lifecycles/getLifecyclePlatforms?access_token=${data.apitoken}&lifecycle_id=${data.lifecycle_id}&env=${env.VUE_APP_env}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
}

const getLifecycleTasks = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_active?access_token=${payload.apitoken}&filter={
"include": ["taskComments","assignedTo"],
"where": {
"facility_id": ${payload.facilityId}
}
}`,{
  method: 'GET',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`
  }
});

const getLifecycleTasksForUser = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_AssignmentsForWorkers?access_token=${payload.apitoken}filter={
"where": {
"facility_id": ${payload.facility_id},
"user_id": ${payload.user_id}
}
}`,{
  method: 'GET',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`
  }
});

const createTaskComment = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_comment?access_token=${payload.apitoken}`,{
  method: 'POST',
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`,
    'content-type': 'application/json'
  },
  body: JSON.stringify(payload)
});

const removeTaskComment = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_comment/${payload.comment_id}?access_token=${payload.apitoken}`,{
  method: 'DELETE',
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`,
    'content-type': 'application/json'
  }
});

const editTaskComment = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_comment/${payload.comment_id}?access_token=${payload.apitoken}`,{
  method: 'PUT',
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`,
    'content-type': 'application/json'
  },
  body: JSON.stringify(payload)
});

const getTaskTypes = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_type?access_token=${payload.apitoken}&filter[order]=label`,{
  method: 'GET',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`
  }
});

const createTask = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_task?access_token=${payload.apitoken}`,{
  method: 'POST',
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`,
    'content-type': 'application/json'
  },
  body: JSON.stringify(payload)
});

const deleteTask = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_task/${payload.task_id}?access_token=${payload.apitoken}`,{
  method: 'DELETE',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`
  }
});

const editTask = (payload) => fetch(`${env.VUE_APP_trimaster}/api/v1/task_task?access_token=${payload.apitoken}`,{
  method: 'PUT',
   mode: 'cors',
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${payload.apitoken}`,
    'content-type': 'application/json'
  },
  body: JSON.stringify(payload)
});

export default {
  getLifecyclePlatforms,
  getLifecycleTasks,
  getLifecycleTasksForUser,
  createTaskComment,
  removeTaskComment,
  editTaskComment,
  getTaskTypes,
  createTask,
  deleteTask,
  editTask
}
